import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import Chat from './pages/chat/Chat';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { v4 as uuidv4 } from 'uuid';

// 重定向组件
const ChatRedirect: React.FC = () => {
  const { account_id } = useParams<{ account_id: string }>();
  const threadId = uuidv4();
  return <Navigate to={`/chat/${account_id}/${threadId}`} replace />;
};

const App: React.FC = () => {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Routes>
          <Route path="/chat/:account_id/:thread_id" element={<Chat />} />
          <Route path="/chat/:account_id" element={<ChatRedirect />} />
          <Route 
            path="/" 
            element={<Navigate to={`/chat/default-account`} replace />} 
          />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;
